import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';

import { Header, MealHeader, MealIngredients, MealMacros, MealWrapper } from './components';
import { Error } from './components/Error/Error';
import { LoadingSkeleton } from './components/LoadingSkeleton/LoadingSkeleton';
import { MealInstructions } from './components/MealInstructions/MealInstructions';
import { useGetMeal } from './hooks/useGetMeal';

import * as S from './styled';

import { useDispatch } from '@/hooks/store';
import { GET_MEAL_BY_ID } from '@/store/nutrition/actionTypes';

export const MealPageModule = () => {
    const { mealId } = useParams();
    const { state: locationState } = useLocation();
    const selectedDate = locationState?.selectedDate ? new Date(locationState.selectedDate) : new Date();
    const { meal, state, copy, trackMealPageLoad } = useGetMeal(selectedDate);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    React.useEffect(() => {
        if (mealId) {
            dispatch({ type: GET_MEAL_BY_ID, payload: { mealId } });
        }
    }, [mealId, dispatch]);

    React.useEffect(() => {
        if (state === 'success' || state === 'error') {
            trackMealPageLoad();
        }
    }, [state, trackMealPageLoad]);

    if (state === 'loading') {
        return <LoadingSkeleton />;
    }

    if (state === 'error') {
        return <Error {...copy} />;
    }

    const { mealType, cover, header, macros, ingredients, instructions } = meal;

    return (
        <S.Container data-locator="meal-page-module" data-testid="meal-page-module">
            <Helmet title={header.name || t('pagesTitles.mealPage')} />
            <Header mealType={mealType} />
            <MealWrapper image={cover}>
                <MealHeader {...header} />
                <MealMacros {...macros} />
                <MealIngredients {...ingredients} />
                <MealInstructions {...instructions} />
            </MealWrapper>
        </S.Container>
    );
};
